import { render, staticRenderFns } from "./SkupTemaEdit.vue?vue&type=template&id=f90eed6c&scoped=true&"
import script from "./SkupTemaEdit.vue?vue&type=script&lang=js&"
export * from "./SkupTemaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90eed6c",
  null
  
)

export default component.exports